import React, {useEffect, useState} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import '../App.css';
import testJson from '.././test/testJson/test.json';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from "../aws-exports";
import API_GATEWAY from "./hostname";
import getCognitoProvider from "./cognite_common";
import loadimg from "../images/loading.gif";

// Amplify from aws-exports
Amplify.configure(awsconfig);
// Auth from aws-exports
Auth.configure(awsconfig);

const getIdToken = () =>{
    return new Promise((resolve, reject) => {
        try{
            Auth.currentSession().then((data) => {
                return resolve(data.getIdToken().getJwtToken());
              });
        }
        catch(e){
            console.log('Not signed in');
            return reject('ID取得失敗')
        }
    })
}

function clientidDialog(name, client_id, secret_id){
    var i = 0;
            while(i < 2){
                if(i==0){
                    var res1 = window.prompt(name + "を登録しました。\n下記をメモしてください。\nクライアントID：", client_id);
                    if(res1){
                        // OKを押すとクライアントシークレットへ
                        i=1;
                    }
                    else{
                        // キャンセルを押すともう一度表示
                        i=0;
                    }
                }
                else if(i == 1){
                    var res2 = window.prompt("続いて、下記をメモしてください。\nクライアントシークレット：",secret_id);
                    if(res2){
                        // OKを押すとダイアログ終了
                        i=2;
                        break;
                    }
                    else{
                        // キャンセルを押すともう一度クライアントIDから表示
                        i=0;
                    }
                }
            }
}

async function createAppClient(email){
    const [cognitoServiceProvider, thisUser] = await getCognitoProvider();
    try{
        
        const app_client = await cognitoServiceProvider.createUserPoolClient({
            "RefreshTokenValidity": 60,
            "AllowedOAuthFlowsUserPoolClient": true,
            "GenerateSecret":true,
            "AllowedOAuthFlows":["client_credentials"],
            "AllowedOAuthScopes":["jp.co.leadsecurity.webapi/devices.read", "jp.co.leadsecurity.webapi/locks.read", "jp.co.leadsecurity.webapi/locks.write"],
            "ClientName":email,
            "UserPoolId":thisUser.pool.userPoolId,
            "TokenValidityUnits": { 
                "RefreshToken": "days"
             }
        }).promise();
        return app_client;
    }
    catch(error){
        console.log("アプリクライアント作成失敗");
    }
}


async function signUp(customname, password, email, auth, hotels, conts, app_client) {
    const [cognitoServiceProvider, thisUser] = await getCognitoProvider();
    var attributes = {
        email,
        'custom:authority': auth,
        'custom:hotels': hotels,
        'custom:contractors': conts,
        'custom:name': customname
    }
    if(app_client){
        attributes["custom:app_client_id"]=app_client.UserPoolClient.ClientId
    }
    try {
        // リソースサーバーにホテルIDがあるか確認。
        const [cognitoServiceProvider, thisUser] = await getCognitoProvider();
        const result = await cognitoServiceProvider.describeResourceServer({
            Identifier: "jp.co.leadsecurity.webapi",
            UserPoolId: thisUser.pool.userPoolId }).promise();
        let conf = result.ResourceServer;
        let hotel_count = 0;
        let resource_server_count = 0;
        
        hotels.split(' ').forEach(function(hotel){
            if (hotel){
                hotel_count += 1;
                for(var i in conf.Scopes){
                    if (conf.Scopes[i].ScopeDescription == hotel){
                        resource_server_count += 1;
                        break;
                    }
                }
            }
        });
        
        let resourceServerErrorCheck = false;
        // 登録するホテル数と、そのホテルIDがあるリソースサーバーの数が一致しない場合、リソースサーバーに問題があるためエラー。
        if(hotel_count != resource_server_count){
            resourceServerErrorCheck = true;
        }
        if(resourceServerErrorCheck && app_client){
            // リソースサーバーにホテルIDが登録されていない　かつ　WebAPI利用者だった場合エラーを表示してユーザーをつくらない。
            alert("ユーザー作成に失敗いたしました。エラーコード：10");
        }
        else{
            const { user } = await Auth.signUp({
                username: email,
                password: password,
                attributes: attributes
            })
            // 管理者はadminユーザーグループに追加
            var groupName = "";
            if(auth == "admin"){
                groupName = "admin";
                const result = cognitoServiceProvider.adminAddUserToGroup({
                    GroupName: groupName,
                    UserPoolId: thisUser.pool.userPoolId,
                    Username: email,
                }).promise();
            }
            if(app_client){
                 // webAPI利用者登録の時はアプリクライアントにscopeを設定
                updateClientScope(cognitoServiceProvider, thisUser.pool.userPoolId, app_client.UserPoolClient.ClientId, hotels);
                // ダイアログ表示
                clientidDialog(customname, app_client.UserPoolClient.ClientId, app_client.UserPoolClient.ClientSecret)
            }
            else{
                alert(customname + "を登録しました。");
            }
        }
        window.location.href = '/usermanagement';
    } catch (error) {
        // WebAPI利用者の場合は作成したアプリクライアントを削除する
        if(app_client){
            const del_userpoolclient_result = await cognitoServiceProvider.deleteUserPoolClient({
                "ClientId":app_client.UserPoolClient.ClientId,
                "UserPoolId":thisUser.pool.userPoolId
            }).promise();
        }
        alert("ユーザー作成に失敗いたしました");
    }
};

async function updateUser(customname, password, email, auth, hotels, conts, client_id) {
    try {
        // リソースサーバーにホテルIDがあるか確認。
        const [cognitoServiceProvider, thisUser] = await getCognitoProvider();
        const result = await cognitoServiceProvider.describeResourceServer({
            Identifier: "jp.co.leadsecurity.webapi",
            UserPoolId: thisUser.pool.userPoolId }).promise();
        let conf = result.ResourceServer;
        let hotel_count = 0;
        let resource_server_count = 0;
        
        hotels.split(' ').forEach(function(hotel){
            if (hotel){
                hotel_count += 1;
                for(var i in conf.Scopes){
                    if (conf.Scopes[i].ScopeDescription == hotel){
                        resource_server_count += 1;
                        break;
                    }
                }
            }
        });
        
        let resourceServerErrorCheck = false;
        // 登録するホテル数と、そのホテルIDがあるリソースサーバーの数が一致しない場合、リソースサーバーに問題があるためエラー。
        if(hotel_count != resource_server_count){
            resourceServerErrorCheck = true;
        }
        if(resourceServerErrorCheck && auth == "webapi"){
            // リソースサーバーにホテルIDが登録されていない　かつ　WebAPI利用者だった場合エラーを表示してユーザーをつくらない。
            alert("ユーザー作成に失敗いたしました。エラーコード：10");
        }
        else{
            const [cognitoServiceProvider, user] = await getCognitoProvider();
            const result = await cognitoServiceProvider.adminUpdateUserAttributes({
                UserPoolId: user.pool.userPoolId,
                Username: email,
                UserAttributes:[
                    {
                        Name: "email",
                        Value: email
                    },
                    {
                        Name: "custom:name",
                        Value: customname
                    },
                    {
                        Name: "custom:authority",
                        Value: auth
                    },
                    {
                        Name: "custom:hotels",
                        Value: hotels
                    },
                    {
                        Name: "custom:contractors",
                        Value: conts
                    },
                ]
            }).promise();
            // webAPI利用者登録の時はアプリクライアントにscopeを設定
            if(auth == "webapi"){
                updateClientScope(cognitoServiceProvider, user.pool.userPoolId, client_id, hotels);
            }
            // 管理者はadminユーザーグループに追加。それ以外はadminグループ排除
            if(auth == "admin"){
                const res = cognitoServiceProvider.adminAddUserToGroup({
                    GroupName: "admin",
                    UserPoolId: user.pool.userPoolId,
                    Username: email,
                }).promise();
            }else{
                const res = cognitoServiceProvider.adminRemoveUserFromGroup({
                    GroupName: "admin",
                    UserPoolId: user.pool.userPoolId,
                    Username: email,
                }).promise();
            }
            alert(customname + "を更新しました。");
        }
        window.location.href = '/usermanagement';
    } catch (error) {
        alert("ユーザー情報更新に失敗しました");
    }
};

// アプリクライアントにscopeを設定する
async function updateClientScope(provider, pool_id, client_id, hotels) {
    const result = await provider.describeUserPoolClient({
        ClientId: client_id,
        UserPoolId: pool_id }).promise();
    let scopes = result.UserPoolClient.AllowedOAuthScopes;
    let newscopes = [];
    scopes.forEach(function(scope){
        if (scope.indexOf("jp.co.leadsecurity.webapi/hotels.") != 0){
            newscopes.push(scope);
        }
    });
    hotels.split(' ').forEach(function(hotel){
        if (hotel){
            newscopes.push("jp.co.leadsecurity.webapi/hotels." + hotel);
        }
    });
    const result2 = await provider.updateUserPoolClient({
        AllowedOAuthScopes: newscopes,
        AllowedOAuthFlowsUserPoolClient:true,
        AllowedOAuthFlows: ['client_credentials'],
        ClientId: client_id,
        UserPoolId: pool_id }).promise();
}


function Regist_user() {
    const [hotelList, setHotelList] = useState([]);
    const location = useLocation();
    const [admFlag, setAdmFlag] = useState(false);
    const [webAPIFlag, setWebAPIFlag] = useState(false);
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    async function isAdmin(){
        const user = await Auth.currentUserPoolUser();
        const attrs = await Auth.userAttributes(user);
        attrs.forEach(function(attr){
            if (attr.Name == 'custom:authority'){
                if(attr.Value == 'admin'){
                    setAdmFlag(true);
                }else{
                    // admin以外はこの画面に遷移させない
                    history.push({
                        pathname: "/",
                    });
                }
            }
        });
    }

    useEffect(() => {
        isAdmin();
        // 契約者一覧のリンクを取得
        getContractorsLinks()
        .then(result => {
            const contids = result;
            const contids_count = contids.length;
            var count = 0;
            var list = [];
            contids.forEach(function(contid){
                // ホテル一覧のリンクを取得
                getHotelLinks(contid)
                        .then(result => {
                            const hotels = result;
                            const hotels_count = hotels.length;
                            var count2 = 0;
                            if(hotels.length == 0 || hotels == "failed"){
                                count = count+1
                                if(count == contids_count){
                                    setHotelList(list);
                                    setLoading(false);
                                }
                            }
                            hotels.forEach(function(hoteldict){
                                list.push(<li class="li_hotels">
                                            <input class="hotels" id={contid+' '+hoteldict.hotel_id} type="checkbox" onChange={hotelsHandleChange} /> {hoteldict.name}
                                            </li>
                                );

                                if(hotels.indexOf(hoteldict) !== -1){
                                    count2 = count2 + 1;
                                    if(count2 == hotels_count){
                                        if(contids.indexOf(contid) !== -1){
                                            count = count+1;
                                            if(count == contids_count){
                                                setHotelList(list);
                                                setLoading(false);
                                            }
                                        }
                                    }
                                }
                                // if(contids[contids_count-1] == contid){
                                //     if(hotels_count == 0 || hoteldict == hotels[hotels_count-1]){
                                //         setLoading(false)
                                //     }
                                // }
                            });
                            // setHotelList(hotelList.concat(list));
                        }).catch(error => {
                            console.error("ホテル一覧リンク作成失敗")
                            setLoading(false)
                        })
            });
        }).catch(error => {
            console.error("契約者一覧リンク作成失敗")
            setLoading(false)
        })
    },[])
    useEffect(() => {
        // 更新の場合ユーザー情報を取得
        if (updateflag){
            getUserInfo()
                .then(result => {
                    // ユーザー情報設定
                    let elem_name = document.getElementById('customname');
                    elem_name.value = location.state.customname;
                    state.customname = location.state.customname;
                    result.UserAttributes.forEach(function(attr){
                        if (attr.Name === "email"){
                            let element = document.getElementById('email');
                            element.value = attr.Value;
                            state.email = attr.Value;
                        }else if (attr.Name === "custom:authority"){
                            let element = document.getElementById(attr.Value);
                            if (element){
                                element.checked = true;
                                state.auth = attr.Value;
                            }else{
                                // elementない＝webapi
                                state.auth = "webapi";
                                setWebAPIFlag(true);
                            }
                        }else if (attr.Name === "custom:hotels"){
                            let hotelels =document.getElementsByClassName('hotels');
                            const myhotels = attr.Value.split(' ');
                            myhotels.forEach(function(myhotel){
                                for (var i = 0; i < hotelels.length; i++){
                                    const ids = hotelels[i].id.split(' ');
                                    if (ids[1] == myhotel){
                                        hotelels[i].checked = true;
                                    }
                                }
                            });
                        }else if (attr.Name === "custom:app_client_id"){
                            location.state.app_client_id = attr.Value;
                        }
                    });
                }).catch(error => {
                    console.error("ユーザー情報取得失敗")
                });
        }
    },[hotelList])

    const emailHandleChange = (event) => {
        state.email = event.target.value;
    }
    const usernameHandleChange = (event) => {
        state.customname = event.target.value;
    }
    const passwordHandleChange = (event) => {
        state.password = event.target.value;
    }
    const hotelsHandleChange = (event) => {
        return;
        const ids = event.target.id.split(' ');
        if (event.target.checked){
            if (!state.contractors.includes(ids[0])){
                state.contractors.push(ids[0]);
            }
            state.hotels.push(ids[1]);
        }else{
            state.contractors = state.contractors.filter(function(cont){
                return cont != ids[0];
            });
            state.hotels = state.hotels.filter(function(hotel){
                return hotel != ids[1];
            });
        }
    }
    const checkHandleChange = (event) => {
        state.auth = event.target.id;
    }
    const getContractorsLinks = () =>{
        return new Promise((resolve, reject) => {
            try{
                getIdToken()
                .then(result => {
                    const method = "GET";
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                      };
                    fetch(API_GATEWAY + '/console/v1/contractors',
                    {method:method, headers:headers})
                    .then((res)=> res.json())
                      .then(data => {
                        console.log("契約企業一覧取得のfetch実行完了")
                        var list = [];
                        for(var i in data.contractors){
                            list.push(data.contractors[i].contractor_id);
                        }
                        return resolve(list);
                      },[])
                      .catch(err => {
                        console.log("契約企業一覧取得のfetch失敗")
                        alert("契約企業一覧の取得に失敗しました")
                        return reject('契約企業一覧取得失敗')
                        })
                }).catch(error => {
                    console.error("IDトークン取得失敗")
                    return reject('IDトークン取得失敗')
                })
            }
            catch(e){
                console.log('契約者一覧取得失敗');
                return reject('契約者一覧取得失敗')
            }
        })
    }
    const getHotelLinks = (contractorID) =>{
        return new Promise((resolve, reject) => {
            try{
                getIdToken()
                .then(result => {
                    const method = "GET";
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                      };
                    var url = API_GATEWAY + "/console/v1/contractors/"+ contractorID +"/hotels";
                    fetch(url,
                    {method:method, headers:headers})
                    .then((res)=> res.json())
                      .then(data => {
                        console.log("ホテル一覧取得のfetch実行完了")
                        // ソート（文字辞書順）
                        data.hotels.sort(function(a,b){
                            if(a.name < b.name) return -1;
                            if(a.name > b.name) return 1;
                            return 0;
                        });
                        return resolve(data.hotels);
                      },[])
                      .catch(err => {
                        console.log("ホテル一覧取得のfetch失敗")
                        alert("情報取得に失敗したホテルがあります")
                        return resolve("failed")
                        })
                }).catch(error => {
                    console.error("IDトークン取得失敗")
                    return reject('IDトークン取得失敗')
                })
            }
            catch(e){
                console.log('ホテル一覧取得失敗');
                return reject('ホテル一覧取得失敗')
            }
        })
    }
    const getUserInfo = () =>{
        return new Promise((resolve, reject) => {
            try{
                getCognitoUserInfo().then((data) => {
                    return resolve(data);
                });
            }
            catch(e){
                return reject('取得失敗');
            }
        })
    }

    function handleClick(e: React.MouseEvent){
        e.preventDefault(); // フォーム送信を抑止
        getHotelContrator();
        getSelectedAuth();
        // if (state.auth != "admin" && state.hotels.length == 0){
        //     alert("利用ホテルを選択してください");
        //     return;
        // }
        var isInvalid = getIsInvalid()
        if(isInvalid){
            alert(isInvalid)
        }
        else{
            if (updateflag){
                let setting_auth = state.auth;
                if(webAPIFlag){
                    setting_auth = "webapi";
                }
                updateUser(state.customname, state.password, state.email, setting_auth, state.hotels.join(' '), state.contractors.join(' '), location.state.app_client_id);
            }else{
                // webAPI利用者登録の時はアプリクライアントを作成する
                if(state.auth == "webapi"){
                    createAppClient(state.email).then(result=>{
                        signUp(state.customname, state.password, state.email, state.auth, state.hotels.join(' '), state.contractors.join(' '), result);
                    })
                }
                else{
                    signUp(state.customname, state.password, state.email, state.auth, state.hotels.join(' '), state.contractors.join(' '), null);
                }
            }
        }
    }
    function getHotelContrator(){
        state.hotels = [];
        state.contractors = [];
        let hotelels =document.getElementsByClassName('hotels');
        for (var i = 0; i < hotelels.length; i++){
            const ids = hotelels[i].id.split(' ');
            if (hotelels[i].checked){
                state.hotels.push(ids[1]);
                if (!state.contractors.includes(ids[0])){
                    state.contractors.push(ids[0]);
                }
            }
        }
    }
    function getSelectedAuth(){
        state.auth = "";
        let authes =document.getElementsByClassName('auth');
        for (var i = 0; i < authes.length; i++){
            const authID = authes[i].id;
            if (authes[i].checked){
                state.auth = authID;
            }
        }
    }
    async function getCognitoUserInfo() {
        const [cognitoServiceProvider, user] = await getCognitoProvider();
        // ユーザプール内のユーザを取得する
        const result = await cognitoServiceProvider.adminGetUser({
            UserPoolId: user.pool.userPoolId,
            Username: location.state.name
        }).promise();
        return result;
    }

    function getIsInvalid(){
        if (location.state && !state.customname){
            state.customname = location.state.customname;
        }
        const reg_mail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const reg_emoji = /\u{1F3F4}\u{E0067}\u{E0062}(?:\u{E0077}\u{E006C}\u{E0073}|\u{E0073}\u{E0063}\u{E0074}|\u{E0065}\u{E006E}\u{E0067})\u{E007F}|\u{1F469}\u200D\u{1F469}\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F468}(?:\u{1F3FF}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FE}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FE}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FD}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FC}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FB}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FC}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D)?\u{1F468}|[\u{1F468}\u{1F469}]\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}]|[\u{1F468}\u{1F469}]\u200D[\u{1F466}\u{1F467}]|[\u2695\u2696\u2708]\uFE0F|[\u{1F466}\u{1F467}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708])\uFE0F|\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D(?:\u{1F91D}\u200D\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u{1F91D}\u200D\u{1F9D1}|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]))|\u{1F469}(?:\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D[\u{1F468}\u{1F469}]|[\u{1F468}\u{1F469}])|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FF}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FE}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FD}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FC}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FB}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F469}\u{1F3FF}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FE}]|\u{1F469}\u{1F3FE}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|\u{1F469}\u{1F3FD}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|\u{1F469}\u{1F3FC}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|\u{1F469}\u{1F3FB}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FC}-\u{1F3FF}]|\u{1F469}\u200D\u{1F466}\u200D\u{1F466}|\u{1F469}\u200D\u{1F469}\u200D[\u{1F466}\u{1F467}]|(?:\u{1F441}\uFE0F\u200D\u{1F5E8}|\u{1F469}(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F3F3}\uFE0F\u200D\u26A7|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F43B}\u200D\u2744|(?:[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}])\u200D[\u2640\u2642]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]\u200D[\u2640\u2642]|\u{1F3F4}\u200D\u2620|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299\u{1F170}\u{1F171}\u{1F17E}\u{1F17F}\u{1F202}\u{1F237}\u{1F321}\u{1F324}-\u{1F32C}\u{1F336}\u{1F37D}\u{1F396}\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}\u{1F39F}\u{1F3CD}\u{1F3CE}\u{1F3D4}-\u{1F3DF}\u{1F3F5}\u{1F3F7}\u{1F43F}\u{1F4FD}\u{1F549}\u{1F54A}\u{1F56F}\u{1F570}\u{1F573}\u{1F576}-\u{1F579}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F5A5}\u{1F5A8}\u{1F5B1}\u{1F5B2}\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}\u{1F6CB}\u{1F6CD}-\u{1F6CF}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6F0}\u{1F6F3}])\uFE0F|\u{1F469}\u200D\u{1F467}\u200D[\u{1F466}\u{1F467}]|\u{1F3F3}\uFE0F\u200D\u{1F308}|\u{1F469}\u200D\u{1F467}|\u{1F469}\u200D\u{1F466}|\u{1F415}\u200D\u{1F9BA}|\u{1F469}(?:\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F1FD}\u{1F1F0}|\u{1F1F6}\u{1F1E6}|\u{1F1F4}\u{1F1F2}|\u{1F408}\u200D\u2B1B|\u{1F441}\uFE0F|\u{1F3F3}\uFE0F|\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]?|\u{1F1FF}[\u{1F1E6}\u{1F1F2}\u{1F1FC}]|\u{1F1FE}[\u{1F1EA}\u{1F1F9}]|\u{1F1FC}[\u{1F1EB}\u{1F1F8}]|\u{1F1FB}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1EE}\u{1F1F3}\u{1F1FA}]|\u{1F1FA}[\u{1F1E6}\u{1F1EC}\u{1F1F2}\u{1F1F3}\u{1F1F8}\u{1F1FE}\u{1F1FF}]|\u{1F1F9}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1ED}\u{1F1EF}-\u{1F1F4}\u{1F1F7}\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FF}]|\u{1F1F8}[\u{1F1E6}-\u{1F1EA}\u{1F1EC}-\u{1F1F4}\u{1F1F7}-\u{1F1F9}\u{1F1FB}\u{1F1FD}-\u{1F1FF}]|\u{1F1F7}[\u{1F1EA}\u{1F1F4}\u{1F1F8}\u{1F1FA}\u{1F1FC}]|\u{1F1F5}[\u{1F1E6}\u{1F1EA}-\u{1F1ED}\u{1F1F0}-\u{1F1F3}\u{1F1F7}-\u{1F1F9}\u{1F1FC}\u{1F1FE}]|\u{1F1F3}[\u{1F1E6}\u{1F1E8}\u{1F1EA}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F4}\u{1F1F5}\u{1F1F7}\u{1F1FA}\u{1F1FF}]|\u{1F1F2}[\u{1F1E6}\u{1F1E8}-\u{1F1ED}\u{1F1F0}-\u{1F1FF}]|\u{1F1F1}[\u{1F1E6}-\u{1F1E8}\u{1F1EE}\u{1F1F0}\u{1F1F7}-\u{1F1FB}\u{1F1FE}]|\u{1F1F0}[\u{1F1EA}\u{1F1EC}-\u{1F1EE}\u{1F1F2}\u{1F1F3}\u{1F1F5}\u{1F1F7}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1EF}[\u{1F1EA}\u{1F1F2}\u{1F1F4}\u{1F1F5}]|\u{1F1EE}[\u{1F1E8}-\u{1F1EA}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}]|\u{1F1ED}[\u{1F1F0}\u{1F1F2}\u{1F1F3}\u{1F1F7}\u{1F1F9}\u{1F1FA}]|\u{1F1EC}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EE}\u{1F1F1}-\u{1F1F3}\u{1F1F5}-\u{1F1FA}\u{1F1FC}\u{1F1FE}]|\u{1F1EB}[\u{1F1EE}-\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1F7}]|\u{1F1EA}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1ED}\u{1F1F7}-\u{1F1FA}]|\u{1F1E9}[\u{1F1EA}\u{1F1EC}\u{1F1EF}\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1FF}]|\u{1F1E8}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1EE}\u{1F1F0}-\u{1F1F5}\u{1F1F7}\u{1F1FA}-\u{1F1FF}]|\u{1F1E7}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EF}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1E6}[\u{1F1E8}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F2}\u{1F1F4}\u{1F1F6}-\u{1F1FA}\u{1F1FC}\u{1F1FD}\u{1F1FF}]|[#\*0-9]\uFE0F\u20E3|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]|\u{1F3F4}|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}][\u{1F3FB}-\u{1F3FF}]|[\u261D\u270C\u270D\u{1F574}\u{1F590}][\uFE0F\u{1F3FB}-\u{1F3FF}]|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F408}\u{1F415}\u{1F43B}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}]|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F201}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F250}\u{1F251}\u{1F300}-\u{1F320}\u{1F32D}-\u{1F335}\u{1F337}-\u{1F37C}\u{1F37E}-\u{1F384}\u{1F386}-\u{1F393}\u{1F3A0}-\u{1F3C1}\u{1F3C5}\u{1F3C6}\u{1F3C8}\u{1F3C9}\u{1F3CF}-\u{1F3D3}\u{1F3E0}-\u{1F3F0}\u{1F3F8}-\u{1F407}\u{1F409}-\u{1F414}\u{1F416}-\u{1F43A}\u{1F43C}-\u{1F43E}\u{1F440}\u{1F444}\u{1F445}\u{1F451}-\u{1F465}\u{1F46A}\u{1F479}-\u{1F47B}\u{1F47D}-\u{1F480}\u{1F484}\u{1F488}-\u{1F4A9}\u{1F4AB}-\u{1F4FC}\u{1F4FF}-\u{1F53D}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F5A4}\u{1F5FB}-\u{1F644}\u{1F648}-\u{1F64A}\u{1F680}-\u{1F6A2}\u{1F6A4}-\u{1F6B3}\u{1F6B7}-\u{1F6BF}\u{1F6C1}-\u{1F6C5}\u{1F6D0}-\u{1F6D2}\u{1F6D5}-\u{1F6D7}\u{1F6EB}\u{1F6EC}\u{1F6F4}-\u{1F6FC}\u{1F7E0}-\u{1F7EB}\u{1F90D}\u{1F90E}\u{1F910}-\u{1F917}\u{1F91D}\u{1F920}-\u{1F925}\u{1F927}-\u{1F92F}\u{1F93A}\u{1F93F}-\u{1F945}\u{1F947}-\u{1F976}\u{1F978}\u{1F97A}-\u{1F9B4}\u{1F9B7}\u{1F9BA}\u{1F9BC}-\u{1F9CB}\u{1F9D0}\u{1F9E0}-\u{1F9FF}\u{1FA70}-\u{1FA74}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA86}\u{1FA90}-\u{1FAA8}\u{1FAB0}-\u{1FAB6}\u{1FAC0}-\u{1FAC2}\u{1FAD0}-\u{1FAD6}]/gu;
        const reg_pass = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]{8,24}$/;
        if(!state.email){
            return "メールアドレスを入力してください"
        }
        if(!reg_mail.test(state.email)){
            return "正しい形式でメールアドレスを入力してください"
        }
        if(128 < state.email.length){
            return "メールアドレスは最大128文字です"
        }
        if(!state.customname){
            return "ユーザー名を入力してください"
        }
        if(reg_emoji.test(state.customname)){
            return "ユーザー名に絵文字が含まれています"
        }
        if(100 < state.customname.length){
            return "ユーザー名は最大100文字です"
        }
        if(!updateflag){
            if(!state.password){
                return "パスワードを入力してください"
            }
            if(!reg_pass.test(state.password)){
                return "パスワードは「大文字」と「小文字」と「数字」を全て含む８文字以上で設定してください"
            }
        }
    }

    const state = {};
    state.auth = "admin";
    state.hotels = [];
    state.contractors = [];
    let updateflag = false;
    if (location.state){
        updateflag = true;
        state.email = location.state.name;
    }

    if (loading){
        return (

        <div class="center_parents">
            <table class="overall_table">
                <tr>
                    <td>
                        <div class="title_text">
                        {updateflag &&
                        <div>ユーザー情報更新</div>}
                        {!updateflag &&
                        <div>ユーザー新規登録</div>}
                        </div>
                    </td>
                </tr>
            </table>

            <hr color="#00B4C6" size="6" />
            <br />
            <table class="table_border overall_table">
                <tr>
                    <td>
                        <div>
                        <img src={loadimg}/>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        );
    }
    return (
        <div>


        <div class="title_text">
        {updateflag &&
            <div>ユーザー情報更新</div>}
            {!updateflag &&
            <div>ユーザー新規登録</div>}
        </div>
            <hr color="#00B4C6" size="6" />
            <br />

            <table class="table_border overall_table">
                <tr>
                    <td class="table_border_updown_thtd_left">
                        ユーザー名
                    </td>
                    <td class="table_border_updown_thtd_left require">
                        必須
                    </td>
                    <td class="table_border_updown_thtd_right">
                        <input class="textbox" id="customname" type="text" value={state.customname} onChange={usernameHandleChange} maxLength={100}/>
                    </td>
                    <td class="table_border_updown_thtd_right min-text"></td>
                </tr>
                {!updateflag &&
                <tr>
                    <td class="table_border_updown_thtd_left">
                        初期パスワード
                    </td>
                    <td class="table_border_updown_thtd_left require">
                        必須
                    </td>
                    <td class="table_border_updown_thtd_right min-text">
                    <input class="textbox" id="password" type="password" value={state.password} onChange={passwordHandleChange} />
                    </td>
                    <td class="table_border_updown_thtd_right min-text">
                    ※パスワードは「大文字」と「小文字」と「数字」を全て含む８文字以上で設定してください。
                    </td>
                </tr>}
                <tr>
                    <td class="table_border_updown_thtd_left">
                        メールアドレス
                    </td>
                    <td class="table_border_updown_thtd_left require">
                        必須
                    </td>
                    {updateflag &&
                    <td class="table_border_updown_thtd_right">
                        <input class="textbox" id="email" type="text" value={state.email} onChange={emailHandleChange} maxLength={128} disabled/>
                    </td>}
                    {!updateflag &&
                    <td class="table_border_updown_thtd_right">
                        <input class="textbox" id="email" type="text" value={state.email} onChange={emailHandleChange} maxLength={128}/>
                    </td>}
                    <td class="table_border_updown_thtd_right min-text">
                        ※メールアドレスがLeaLockへのログインIDとなります
                    </td>
                </tr>
                {!webAPIFlag &&
                <tr>
                    <td class="table_border_updown_thtd_left">
                        権限
                    </td>
                    <td class="table_border_updown_thtd_left require">
                        必須
                    </td>
                    <td class="table_border_updown_thtd_right">
                    {updateflag &&
                        <input class="auth" id="admin" name="auth" type="radio" onChange={checkHandleChange}/> }
                        {!updateflag &&
                        <input class="auth" id="admin" name="auth" type="radio" onChange={checkHandleChange} defaultChecked />}
                        管理者
                        <br></br>
                        <input class="auth" id="contractor" name="auth" type="radio" onChange={checkHandleChange} />契約者
                        <br></br>
                        <input class="auth" id="installation" name="auth" type="radio" onChange={checkHandleChange} />設置工事者
                        <br></br>
                        {!updateflag &&
                        <div>
                        <input class="auth" id="webapi" name="auth" type="radio" onChange={checkHandleChange} />
                            WebAPI利用者
                        </div>}
                    </td>
                    <td class="table_border_updown_thtd_right min-text"></td>
                </tr>}
                <tr>
                    <td class="table_border_updown_thtd_left">
                        利用ホテル
                    </td>
                    <td class="table_border_updown_thtd_left require">
                        　
                    </td>
                    <td class="table_border_updown_thtd_right min-text">
                        {hotelList}
                    </td>
                    <td class="table_border_updown_thtd_right min-text"></td>
                </tr>
            </table>
            <br />
            <div class="center">
                <button class="regist_button" type="submit" value="登録" onClick={handleClick.bind(this)}>登録</button>
                <Link class="back_link" to={`/usermanagement`}>戻る</Link>
            </div>
        </div>
    );
}

export default Regist_user;
